// extracted by mini-css-extract-plugin
export default {"form":"login_form__nHwcM"};